module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sean Williams, Shane Dix\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sean Williams writes for children, young adults, and adults. He is the author of forty novels, ninety short stories, and the odd odd poem, and has also written in universes created by other people, such as those of Star Wars and "), _c('I', [_vm._v("Doctor Who")]), _vm._v(". His work has won awards, debuted at number one on the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestseller list, and been translated into numerous languages. His latest novel is "), _c('I', [_vm._v("Twinmaker")]), _vm._v(", the first in a new series that takes his love affair with the matter transmitter to a whole new level (he just received a PhD on the subject, so don’t get him started).")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/82q8Nv/tc-custom/9781480495364.jpg?1733024683817",
      "alt": "This image is the cover for the book Echoes of Earth, The Orphans Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Echoes of Earth, The Orphans Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this “dazzling adventure” from the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author, a man adrift in space finds himself facing the edge of madness (Jack McDevitt). ")]), _c('br'), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" The Frank Tipler is just one of a thousand survey vessels sent out into the bubble of space surrounding Earth, seeking habitable worlds and signs of advanced life. Its crew has stumbled across artifacts left behind by a benevolent trader species, but the decision to study them is fraught with danger and uncertainty. The Tipler's crew consists of forty flawed electronic copies of human beings, some of them profoundly damaged—and Earth stopped responding to signals over a century ago."), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" Caught between madness and political machinations, Alander stands on the brink of what might be the greatest discovery humanity has ever made—and a gift that humanity can’t afford to accept."), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" “ECHOES OF EARTH is a dazzling adventure, sweeping the reader along from marvel to wonder, and it includes one of the most heart-stopping moments I've encountered in a novel in years.” —Jack McDevitt"), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" “[The] book can't be discussed or even described without spoiling some of the surprises, which are mutually reinforcing as well as juicy in themselves. I will, however, give in to the temptation to drop a few more of the names that came to mind as I was reading: the Three Gregs (Bear, Benford, Egan), Linda Nagata, and Frederik Pohl…. As the first of a series... ECHOES promises to rev its Ideas right past the red-line and drive them hard.” —Locus"), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" “The science in Dix and Williams’s work shines, entrancing with its glitter and innovation… and you won’t find any of their novels without fully-fleshed out characters, complex plots, vivid settings and thoughtful exploration of issues.” —SF Site"), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" “The authors have already made a name for themselves as writers of intelligent space opera, and ECHOES OF EARTH is sure to further bolster that reputation. The book is chock full of marvelous events, cosmic significance, mysterious alien motivations, and the wonder of outer space.” —Science Fiction Chronicle"), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" Winner of the Ditmar Award. \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0